module.exports = __webpack_public_path__ + "static/0044-b46734f71b20a2431779d728794d3981.png";